import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueSwal from 'vue-swal';
import VeeValidate from 'vee-validate';
import Toasted from 'vue-toasted';
import axios from 'axios';
import VModal from 'vue-js-modal';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import LoadingButton from './components/general/LoadingButton.vue';
import { i18n } from './plugins/i18n';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueSwal);
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors',
});
Vue.use(Toasted, {
  duration: 3000,
  theme: 'bubble',
  iconPack: 'fontawesome',
});
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

// Set axios base url
// Local
// axios.defaults.baseURL = '//localhost:3000';
// Dev
axios.defaults.baseURL = '//apidev.scanmyaudio.com';

Vue.component('loading-button', LoadingButton);

new Vue({
  router,
  store,
  created() {
    // Retrieve user details from localStorage
    const userJwt = localStorage.getItem('userJwt');
    const userString = localStorage.getItem('user');
    if (userJwt && userString) {
      const userData = JSON.parse(userString);
      this.$store.commit('account/SET_JWT', userJwt);
      this.$store.commit('account/SET_USER_DATA', userData);
    }
    // Route the user to the logout page if we receive a token related error from API
    axios.interceptors.response.use(
      response => response,
      (error) => {
        if (error.response.status === 401 && error.response.data.message === 'TOKEN_ERROR') {
          this.$store.dispatch('account/logout');
        }
        return Promise.reject(error);
      },
    );
  },
  i18n,
  render: h => h(App),
}).$mount('#app');
